import {config} from './../../enviroment';
import { store } from "../../helpers/store";
 
const ChatWidget = () => {
    if(!window.RocketChat) {
    (function(w, d, s, u) {
        w.RocketChat = function(c) { w.RocketChat._.push(c) };
        w.RocketChat._ = [];
        w.RocketChat.url = u;
        var h = d.getElementsByTagName(s)[0],
              j = d.createElement(s);
        j.async = true;
        j.src = `${config.urls.ROCKET_CHAT_WIDGET}rocketchat-livechat.min.js`;
        h.parentNode.insertBefore(j, h);
       w.RocketChat(function() {
        let storeData = null;
        store.subscribe(()=>{
            storeData = store.getState();
            if(storeData.accountInformation.accountDetails != null || storeData.accountInformation.accountDetails != undefined ){
                this.setCustomField('accountId', storeData?.accountInformation?.accountDetails?Array.isArray(storeData?.accountInformation?.accountDetails)?storeData?.accountInformation?.accountDetails[0]?.accountId:storeData?.accountInformation?.accountDetails?.accountId:"")
                this.setCustomField('customerNumber', storeData.meterDetails?storeData.meterDetails.customerNumber:"");
                this.setGuestName(storeData.profileDetails ? storeData.profileDetails.firstName +" "+storeData.profileDetails.lastName: '');
                this.setGuestEmail(storeData.profileDetails ?storeData.profileDetails.email : '');
            }
        });
        
        });
        })(window, document, 'script', config.urls.ROCKET_CHAT_WIDGET);
    }
}
 
export default ChatWidget;